module.exports = __webpack_public_path__ + "static/media/balotoRounded.a83209bd.png";